<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">送货单号</label>
            <span class="weui-form-preview__value">{{initData.pi_inoutno}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">送货日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.pi_date}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">供应商名称</label>
            <span class="weui-form-preview__value">{{initData.ve_name}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">币种</label>
            <span class="weui-form-preview__value">{{initData.pi_currency}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">业务员</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">
              {{initData.pi_seller || ''}}
              {{initData.em_mobile || ''}}
              <call-mobile :mobile="initData.em_mobile"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物流单号</label>
            <span class="weui-form-preview__value" v-if="initData.expressInfo">{{initData.expressInfo.expressInc}} {{initData.expressInfo.expressCode}}</span>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd form-detail-preview" v-for="item in initData.listDetail" :key="item.outpddetno">
          <div class="form-detail-preview_num">{{ item.outpddetno }}</div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">供应商料号</label>
            <span class="weui-form-preview__value">{{item.outpdprcode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">采购单号</label>
            <span class="weui-form-preview__value">{{item.pd_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">付款方式</label>
            <span class="weui-form-preview__value">{{item.pu_payments}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料编号</label>
            <span class="weui-form-preview__value">{{item.pd_prodcode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">待收货数量</label>
            <span class="weui-form-preview__value">{{item.qty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料名称</label>
            <span class="weui-form-preview__value">{{item.pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">型号</label>
            <span class="weui-form-preview__value">{{item.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">规格</label>
            <span class="weui-form-preview__value">{{item.pr_spec}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单位</label>
            <span class="weui-form-preview__value">{{item.pr_unit}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">含税单价（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.pd_price}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">厂家/品牌</label>
            <span class="weui-form-preview__value">{{item.pr_brand}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bar weui-dialog__ft">
      <div class="weui-dialog__btn weui-dialog__btn_primary" @click="turnIn">转入库</div>
      <express class="weui-dialog__btn weui-dialog__btn_primary" :exInfo="initData.expressInfo" v-if="initData.expressInfo"></express>
    </div>
  </div>
</template>

<script>
import CallMobile from "@/components/button/CallMobile.vue";
import Express from "@/components/button/Express.vue";

export default {
  components: {
    CallMobile,
    Express
  },
  props: {
    initData: Object
  },
  methods: {
    turnIn() {
      let me = this
      let baseDTOs = []
      me.initData.listDetail.forEach(e => {
        let temp = {}
        temp.id = e.pd_id
        temp.qty = e.qty
        temp.from_cop = e.outcop
        temp.from_type = "SaleOut"
        temp.from_main_id = e.outpiid
        temp.from_code = e.outcode
        temp.from_detail_id = e.outpdid
        baseDTOs.push(temp)
      });
      me.$loading({
        url: '/api/purchase/purchase/turnPurchaseIn',
        method: 'POST',
        jsonData: {
          baseDTOs
        }
      }).then(function (res) {
        if (res.success) {
          me.$weui.toast('入库成功', 1000);
          setTimeout(function () {
            me.$router.push(`/purchase/verify_apply/${res.data.id}`)
          }, 1000);
        } else {
          me.$router.push({
            name: "Error",
            params: res
          });
        }
      });
    }
  }
};
</script>